// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#canvas-zone {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 30px 1fr 10px 40px;
  overflow: hidden;
  position: relative;
}
#canvas-zone #graph {
  grid-column: 1;
  grid-row: 2;
  width: 100%;
  height: 100%;
  background: #222222;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 100%;
  overflow: hidden;
  position: relative;
}
#canvas-zone #graph #svg-graph-grid {
  grid-column: 1;
  grid-row: 1;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}
#canvas-zone #graph #svg-graph-grid:focus {
  outline: none;
}
#canvas-zone #graph #svg-graph-horizontal {
  grid-column: 1;
  grid-row: 1;
  margin-left: 40px;
  width: calc(100% - 40px);
  height: 100%;
  pointer-events: none;
  z-index: 1;
}
#canvas-zone #graph #svg-graph-horizontal:focus {
  outline: none;
}
#canvas-zone #graph #dark-rectangle {
  grid-column: 1;
  grid-row: 1;
  margin-left: 40px;
  width: calc(100% - 40px);
  height: 100%;
  background: #111111;
  opacity: 0.2;
  pointer-events: none;
  position: absolute;
}
#canvas-zone #graph #block-rectangle {
  grid-column: 1;
  grid-row: 1;
  width: 40px;
  height: 100%;
  background: #222222;
  z-index: 1;
}
#canvas-zone #graph #svg-graph-curves {
  grid-column: 1;
  grid-row: 1;
  margin-left: 40px;
  width: calc(100% - 40px);
  height: 100%;
  z-index: 2;
}
#canvas-zone #graph #svg-graph-curves:focus {
  outline: none;
}
#canvas-zone #graph #selection-rectangle {
  grid-column: 1;
  grid-row: 1;
  width: calc(100% - 40px);
  height: 100%;
  pointer-events: none;
  position: absolute;
  left: 40px;
  visibility: hidden;
  border: 1px dashed white;
}
#canvas-zone #range-frame-bar {
  grid-column: 1;
  grid-row: 4;
  width: 100%;
  height: 100%;
  background: #222222;
  pointer-events: none;
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: 100%;
  pointer-events: none;
  user-select: none;
}
#canvas-zone #range-frame-bar #svg-range-frames {
  grid-column: 1;
  grid-row: 1;
  width: 100%;
  height: 100%;
}
#canvas-zone #frame-bar {
  grid-column: 1;
  grid-row: 1;
  width: 100%;
  height: 100%;
  background: #222222;
  pointer-events: none;
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: 40px 1fr;
}
#canvas-zone #frame-bar #angle-unit {
  grid-column: 1;
  grid-row: 1;
  background: #111111;
}
#canvas-zone #frame-bar #frames {
  grid-column: 1/3;
  grid-row: 1;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: 100%;
}
#canvas-zone #frame-bar #frames #svg-frames {
  margin-left: 40px;
  grid-column: 1;
  grid-row: 1;
  width: calc(100% - 40px);
  height: 100%;
}
#canvas-zone #play-head-control {
  grid-column: 1;
  grid-row: 1;
  position: absolute;
  height: 30px;
  left: 40px;
  width: calc(100% - 40px);
}
#canvas-zone #play-head-control-2 {
  grid-column: 1;
  grid-row: 4;
  position: absolute;
  height: 30px;
  left: 0px;
  width: 100%;
}
#canvas-zone #play-head {
  grid-column: 1;
  grid-row: 1/3;
  position: absolute;
  top: 0;
  height: calc(100% - 5px);
  width: 22px;
  margin-left: 40px;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 22px 1fr;
  transform: translateX(-50%);
  pointer-events: none;
  z-index: 3;
}
#canvas-zone #play-head #play-head-bar {
  grid-row: 2;
  grid-column: 1;
  justify-self: center;
  width: 1.5px;
  background: #ffffff;
  height: 100%;
  pointer-events: none;
}
#canvas-zone #play-head #play-head-circle {
  grid-row: 1;
  grid-column: 1;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #ffffff;
  font-family: "acumin-pro-condensed";
  font-size: 8pt;
  display: grid;
  align-content: center;
  justify-content: center;
  color: #555555;
  cursor: pointer;
}
#canvas-zone #angle-mode {
  grid-column: 1;
  grid-row: 1;
  width: 40px;
  height: 100%;
  z-index: 1;
  background: #222222;
}`, "",{"version":3,"sources":["webpack://./../../../dev/inspector/dist/components/actionTabs/tabs/propertyGrids/animations/curveEditor/scss/canvas.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,2BAAA;EACA,sCAAA;EACA,gBAAA;EACA,kBAAA;AACJ;AACI;EACI,cAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,2BAAA;EACA,wBAAA;EACA,gBAAA;EACA,kBAAA;AACR;AACQ;EACI,cAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EAKA,UAAA;AAHZ;AAAY;EACI,aAAA;AAEhB;AAGQ;EACI,cAAA;EACA,WAAA;EACA,iBAAA;EACA,wBAAA;EACA,YAAA;EACA,oBAAA;EAKA,UAAA;AALZ;AAEY;EACI,aAAA;AAAhB;AAKQ;EACI,cAAA;EACA,WAAA;EACA,iBAAA;EACA,wBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;AAHZ;AAMQ;EACI,cAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;AAJZ;AAOQ;EACI,cAAA;EACA,WAAA;EACA,iBAAA;EACA,wBAAA;EACA,YAAA;EACA,UAAA;AALZ;AAOY;EACI,aAAA;AALhB;AASQ;EACI,cAAA;EACA,WAAA;EACA,wBAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EAEA,wBAAA;AARZ;AAYI;EACI,cAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,wBAAA;EACA,2BAAA;EACA,oBAAA;EACA,iBAAA;AAVR;AAYQ;EACI,cAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AAVZ;AAcI;EACI,cAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EAEA,aAAA;EACA,wBAAA;EACA,+BAAA;AAbR;AAeQ;EACI,cAAA;EACA,WAAA;EACA,mBAAA;AAbZ;AAgBQ;EACI,gBAAA;EAEA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,wBAAA;EACA,2BAAA;AAfZ;AAiBY;EACI,iBAAA;EACA,cAAA;EACA,WAAA;EACA,wBAAA;EACA,YAAA;AAfhB;AAoBI;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,wBAAA;AAlBR;AAqBI;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;AAnBR;AAsBI;EACI,cAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;EACA,wBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,2BAAA;EACA,4BAAA;EACA,2BAAA;EACA,oBAAA;EACA,UAAA;AApBR;AAsBQ;EACI,WAAA;EACA,cAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;AApBZ;AAuBQ;EACI,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,mCAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AArBZ;AAyBI;EACI,cAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AAvBR","sourcesContent":["#canvas-zone {\r\n    display: grid;\r\n    grid-template-columns: 100%;\r\n    grid-template-rows: 30px 1fr 10px 40px;\r\n    overflow: hidden;\r\n    position: relative;\r\n\r\n    #graph {\r\n        grid-column: 1;\r\n        grid-row: 2;\r\n        width: 100%;\r\n        height: 100%;\r\n        background: #222222;\r\n        display: grid;\r\n        grid-template-columns: 100%;\r\n        grid-template-rows: 100%;\r\n        overflow: hidden;\r\n        position: relative;\r\n\r\n        #svg-graph-grid {\r\n            grid-column: 1;\r\n            grid-row: 1;\r\n            width: 100%;\r\n            height: 100%;\r\n            pointer-events: none;\r\n\r\n            &:focus {\r\n                outline: none;\r\n            }\r\n            z-index: 1;\r\n        }\r\n\r\n        #svg-graph-horizontal {\r\n            grid-column: 1;\r\n            grid-row: 1;\r\n            margin-left: 40px;\r\n            width: calc(100% - 40px);\r\n            height: 100%;\r\n            pointer-events: none;\r\n\r\n            &:focus {\r\n                outline: none;\r\n            }\r\n            z-index: 1;\r\n        }\r\n\r\n        #dark-rectangle {\r\n            grid-column: 1;\r\n            grid-row: 1;\r\n            margin-left: 40px;\r\n            width: calc(100% - 40px);\r\n            height: 100%;\r\n            background: #111111;\r\n            opacity: 0.2;\r\n            pointer-events: none;\r\n            position: absolute;\r\n        }\r\n\r\n        #block-rectangle {\r\n            grid-column: 1;\r\n            grid-row: 1;\r\n            width: 40px;\r\n            height: 100%;\r\n            background: #222222;\r\n            z-index: 1;\r\n        }\r\n\r\n        #svg-graph-curves {\r\n            grid-column: 1;\r\n            grid-row: 1;\r\n            margin-left: 40px;\r\n            width: calc(100% - 40px);\r\n            height: 100%;\r\n            z-index: 2;\r\n\r\n            &:focus {\r\n                outline: none;\r\n            }\r\n        }\r\n\r\n        #selection-rectangle {\r\n            grid-column: 1;\r\n            grid-row: 1;\r\n            width: calc(100% - 40px);\r\n            height: 100%;\r\n            pointer-events: none;\r\n            position: absolute;\r\n            left: 40px;\r\n            visibility: hidden;\r\n\r\n            border: 1px dashed white;\r\n        }\r\n    }\r\n\r\n    #range-frame-bar {\r\n        grid-column: 1;\r\n        grid-row: 4;\r\n        width: 100%;\r\n        height: 100%;\r\n        background: #222222;\r\n        pointer-events: none;\r\n        display: grid;\r\n        grid-template-rows: 100%;\r\n        grid-template-columns: 100%;\r\n        pointer-events: none;\r\n        user-select: none;\r\n\r\n        #svg-range-frames {\r\n            grid-column: 1;\r\n            grid-row: 1;\r\n            width: 100%;\r\n            height: 100%;\r\n        }\r\n    }\r\n\r\n    #frame-bar {\r\n        grid-column: 1;\r\n        grid-row: 1;\r\n        width: 100%;\r\n        height: 100%;\r\n        background: #222222;\r\n        pointer-events: none;\r\n\r\n        display: grid;\r\n        grid-template-rows: 100%;\r\n        grid-template-columns: 40px 1fr;\r\n\r\n        #angle-unit {\r\n            grid-column: 1;\r\n            grid-row: 1;\r\n            background: #111111;\r\n        }\r\n\r\n        #frames {\r\n            grid-column: 1 / 3;\r\n\r\n            grid-row: 1;\r\n            width: 100%;\r\n            height: 100%;\r\n            display: grid;\r\n            grid-template-rows: 100%;\r\n            grid-template-columns: 100%;\r\n\r\n            #svg-frames {\r\n                margin-left: 40px;\r\n                grid-column: 1;\r\n                grid-row: 1;\r\n                width: calc(100% - 40px);\r\n                height: 100%;\r\n            }\r\n        }\r\n    }\r\n\r\n    #play-head-control {\r\n        grid-column: 1;\r\n        grid-row: 1;\r\n        position: absolute;\r\n        height: 30px;\r\n        left: 40px;\r\n        width: calc(100% - 40px);\r\n    }\r\n\r\n    #play-head-control-2 {\r\n        grid-column: 1;\r\n        grid-row: 4;\r\n        position: absolute;\r\n        height: 30px;\r\n        left: 0px;\r\n        width: 100%;\r\n    }\r\n\r\n    #play-head {\r\n        grid-column: 1;\r\n        grid-row: 1 / 3;\r\n        position: absolute;\r\n        top: 0;\r\n        height: calc(100% - 5px);\r\n        width: 22px;\r\n        margin-left: 40px;\r\n        display: grid;\r\n        grid-template-columns: 100%;\r\n        grid-template-rows: 22px 1fr;\r\n        transform: translateX(-50%);\r\n        pointer-events: none;\r\n        z-index: 3;\r\n\r\n        #play-head-bar {\r\n            grid-row: 2;\r\n            grid-column: 1;\r\n            justify-self: center;\r\n            width: 1.5px;\r\n            background: #ffffff;\r\n            height: 100%;\r\n            pointer-events: none;\r\n        }\r\n\r\n        #play-head-circle {\r\n            grid-row: 1;\r\n            grid-column: 1;\r\n            width: 22px;\r\n            height: 22px;\r\n            border-radius: 50%;\r\n            background: #ffffff;\r\n            font-family: \"acumin-pro-condensed\";\r\n            font-size: 8pt;\r\n            display: grid;\r\n            align-content: center;\r\n            justify-content: center;\r\n            color: #555555;\r\n            cursor: pointer;\r\n        }\r\n    }\r\n\r\n    #angle-mode {\r\n        grid-column: 1;\r\n        grid-row: 1;\r\n        width: 40px;\r\n        height: 100%;\r\n        z-index: 1;\r\n        background: #222222;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
